import { PresetMedia } from '@nucleus/types/web';

export const sectionBackground: PresetMedia = {
  mediaOptions: {
    blending: {
      fade: 'bottom',
      opacity: 0.15,
      blendMode: 'none',
      fadeIntensity: 0.3,
    },
    image: {
      tile: 'none',
      scale: 'cover',
    },
    video: {
      image: {
        tile: 'none',
        scale: 'cover',
      },
    },
    useColor: false,
  },
};
